import wait from '#src/client/common/utils/time/wait.js';
import errorToObj from '#src/client/common/utils/errorToObj.js';

const genFetchError = async (error) => {
    console.log(error);

    return [
        [
            errorToObj(error),
        ],
        undefined,
    ];
};

const parseJson = async (fetchResponse) => {
    try {
        const content = await fetchResponse.json();
        return [undefined, content];
    }
    catch (e) {
        return genFetchError(`The response from the server was not valid data. FetchResponse must be JSON.\n${e.message}`);
    }
};

export const genRequest = async (options) => {
    const { url, body, method, ...otherOptions } = options;
    let convertedBody = body;

    // Prep Body

    // Assumes that what we send to the server is either JSON or FormData.
    const isJson = Object.prototype.toString.call(body) !== '[object FormData]';

    if (isJson) {
        try {
            convertedBody = JSON.stringify(convertedBody);
        }
        catch (e) {
            return genFetchError(`Could not convert data for transmission to server.\n${e.message}`);
        }
    }


    // Prep Options
    const fetchOptions = {
        ...otherOptions,
        method: method ?? 'POST',
        headers: {
            ...otherOptions.headers,
        },
    };

    if (convertedBody) {
        fetchOptions.body = convertedBody;
    }

    if (isJson) {
        fetchOptions.headers['Content-Type'] = 'application/json';
    }


    // Perform Fetch
    let fetchResponse;

    try {
        fetchResponse = await fetch(url, fetchOptions);
    }
    catch (e) {
        return genFetchError(new Error(`Failed to connect to server. Perhaps your internet connectivity is down?\n${e.message}`));
    }


    // Primary Error Handling
    if (!fetchResponse.ok) {
        if (fetchResponse.status === 404) {
            return genFetchError(new Error(`Unrecognized request url: "${url}".`));
        }

        if (fetchResponse.status === 413) {
            return genFetchError(new Error(`Could not complete the request because an uploaded file was too large. Try using a smaller version of the file you were trying to send.`));
        }

        const [errors, content] = await parseJson(fetchResponse);

        if (errors) {
            return [errors, content];
        }

        const isWrongFormat = (
            Object.prototype.toString.call(content) !== '[object Object]'
            || !Array.isArray(content.errors)
            || content.errors.length === 0
        );

        if (isWrongFormat) {
            console.log('The error content is in the wrong format:');
            console.log(content);
            return genFetchError(new Error('An error occurred, but we cannot determine exactly what happened.'));
        }

        return [
            content.errors,
            undefined,
        ];
    }


    // Prepping Success
    const [errors, content] = await parseJson(fetchResponse);

    if (errors) {
        return [errors, content];
    }


    // Handle Redirects Directly
    if (content?.redirect) {
        window.location.href = content.redirect;

        // Prevent page code continuing after a navigation operation.
        // Otherwise you risk strange state on the page.
        await wait(10000);
    }

    // No problems detected.
    return [undefined, content];
};

export default {
    genRequest,
};
